import gql from 'graphql-tag';

export const SEARCH_EVERYTHING = gql`
  query SearchEverything($query: String!, $cursor: String, $filters: SearchFilters!, $sortOrder: SearchSortOrder!) {
    currentUser {
      __typename
      id
      domain {
        __typename
        id
        search(query: $query, cursor: $cursor, limit: 30, filters: $filters, sortOrder: $sortOrder) {
          nextCursor
          items {
            __typename
            id
            body {
              __typename
              ... on SearchPostBody {
                __typename
                permalink
                title
                author
                body
                createdAt
                updatedAt
                publishStatus
                postType
                plexId
              }
              ... on SearchQuestionBody {
                __typename
                permalink
                text
                author
                createdAt
                updatedAt
                questionStatus
                plexId
                acceptedAnswerBody
              }
            }
          }
        }
      }
    }
  }
`;
